import { FileText, ExternalLink } from "lucide-react";
import { Empty, fmtDate } from "../platform/athlete/shared";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Resources({ resources }) {
  if (!resources || resources.length === 0) return <Empty testid="academy-resources-empty">No resources yet. Guides and documents from your coach will appear here.</Empty>;
  return (
    <div className="space-y-2" data-testid="academy-resources-list">
      {resources.map((r) => (
        <div key={r.id} data-testid={`academy-resource-${r.id}`} className="bg-[#121212] border border-white/10 p-4 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <FileText size={18} className="text-white/50 shrink-0" />
            <div className="min-w-0">
              <p className="font-bold truncate">{r.title}</p>
              <p className="text-white/40 text-xs">{[r.category, fmtDate(r.created_at)].filter(Boolean).join(" · ")}</p>
            </div>
          </div>
          <a data-testid={`academy-resource-open-${r.id}`} href={`${BACKEND}/api/resources/${r.id}/file`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 border border-white/20 px-3 py-2 text-xs uppercase tracking-widest font-bold hover:bg-white hover:text-black transition-colors shrink-0"><ExternalLink size={13} /> Open</a>
        </div>
      ))}
    </div>
  );
}
